const mixin = {
    methods: {
     _logout() {
         localStorage.removeItem('token')
         localStorage.removeItem('role_name')
         localStorage.removeItem('status')
     },
     errorHandler({code, msg}, callback) {
        switch(code) {
            case 40005:
            case 40004:
            case 40001:
                this._logout()
                callback()
        }
     }
    }
  }

export default mixin